var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M643.541333 566.613333l77.269334 77.226667-209.152 209.152-209.109334-209.152 77.269334-77.226667 131.84 132.522667 131.84-132.565333z m131.882667-131.925333L853.333333 512l-77.226666 77.226667L698.837333 512l76.586667-77.226667z m-263.722667 0l77.226667 76.586667-77.269333 77.269333L434.432 512l77.226667-77.226667z m-263.765333 0L324.565333 512l-76.586666 76.586667L170.666667 511.957333l77.226666-77.226666z m263.765333-263.765333l209.152 208.469333-77.312 77.226667-131.84-131.84-131.84 132.522666-77.312-77.226666 209.152-209.152z",
    fill: "#EBBB4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceWalletIcon);
export default __webpack_public_path__ + "static/media/binance-wallet-icon.8ef2c0c0df230aa1091a333ca3cf81cd.svg";
export { ForwardRef as ReactComponent };